import { Directive, OnInit, EventEmitter, Output, ElementRef, Input } from '@angular/core';
import { PickadateContext } from 'app/shared/models/timetables.model';
import * as moment from 'moment';
declare var $: any;
@Directive({
    selector: '[pickatime]'
})
export class PickatimeDirective implements OnInit {
    @Output() valueChange: EventEmitter<PickadateContext> = new EventEmitter();



    private $input: any;
    private _picker: PickatimeDirective;
    private element: ElementRef;

    constructor(private _element: ElementRef) {
        this.element = _element;
    }

    ngOnInit() {
        const opts = {
            onSet: this.onSetValue
        };
        const $input = $(this._element.nativeElement);
        $input.pickatime(opts);
    }
    private onSetValue = (v: PickadateContext) => {
        this.valueChange.emit(v);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pick-time/pickatime.directive.ts